// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3w2lk","title":"styles_title__je+IW","description":"styles_description__o6Vil","content":"styles_content__egu5L"};